"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
var React = require("react");
var classnames_1 = require("classnames");
var react_resize_detector_1 = require("react-resize-detector");
var ChevronLeft_svg_1 = require("../../assets/icons/ChevronLeft.svg");
var ChevronRight_svg_1 = require("../../assets/icons/ChevronRight.svg");
var TPAComponentsConfig_1 = require("../TPAComponentsConfig");
var ScrollableTabs_1 = require("./ScrollableTabs");
var TabsNavButton_1 = require("./TabsNavButton");
var constants_1 = require("./constants");
var dataHooks_1 = require("./dataHooks");
var Tabs_st_css_1 = require("./Tabs.st.css");
var SCROLL_EPSILON = 15;
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            navButtons: "none" /* none */,
            animateIndicator: false,
            selectedTab: _this.props.activeTabIndex,
        };
        _this._onClickLeft = function () {
            _this._tabsRef.scrollLeft();
        };
        _this._onClickRight = function () {
            _this._tabsRef.scrollRight();
        };
        _this._onClickItem = function (index) {
            var _a = _this.props, activeTabIndex = _a.activeTabIndex, onTabClick = _a.onTabClick;
            if (index !== activeTabIndex) {
                onTabClick(index);
            }
        };
        _this._updateButtonsIfNeeded = function () {
            var navButtons = _this.state.navButtons;
            var newNavButtons = _this._getNewNavButtons();
            if (newNavButtons !== navButtons) {
                _this.setState({ navButtons: newNavButtons });
            }
        };
        _this._onResize = function () {
            clearTimeout(_this._resizeTimer);
            _this._updateButtonsIfNeeded();
            _this._resizeTimer = setTimeout(function () {
                _this._tabsRef.updateIndicatorPosition();
            }, 100);
        };
        _this._tabsRefCallback = function (el) {
            _this._tabsRef = el;
        };
        _this._leftButtonRefCallback = function (el) {
            _this._leftButtonRef = el;
        };
        _this._rightButtonRefCallback = function (el) {
            _this._rightButtonRef = el;
        };
        return _this;
    }
    Tabs.getDerivedStateFromProps = function (props, state) {
        var newState = null;
        if (state.selectedTab !== props.activeTabIndex) {
            newState = {
                navButtons: state.navButtons,
                animateIndicator: true,
            };
        }
        return newState;
    };
    Tabs.prototype.componentDidMount = function () {
        this._updateButtonsIfNeeded();
    };
    Tabs.prototype.componentDidUpdate = function () {
        var _this = this;
        var selectedTab = this.state.selectedTab;
        var activeTabIndex = this.props.activeTabIndex;
        clearTimeout(this._indicatorTimer);
        if (selectedTab !== activeTabIndex) {
            this.setState({ selectedTab: activeTabIndex, animateIndicator: true }, function () {
                _this._indicatorTimer = setTimeout(function () {
                    _this.setState({
                        animateIndicator: false,
                    });
                }, 350);
            });
        }
        this._updateButtonsIfNeeded();
    };
    Tabs.prototype.componentWillUnmount = function () {
        clearTimeout(this._resizeTimer);
        clearTimeout(this._indicatorTimer);
    };
    Tabs.prototype._getNewNavButtons = function () {
        var scrollPosition = this._tabsRef.getNavScrollPosition();
        var newNavButtons = "none" /* none */;
        if (scrollPosition.scrollLeft >= SCROLL_EPSILON) {
            newNavButtons = "left" /* left */;
        }
        if (scrollPosition.scrollRight >= SCROLL_EPSILON) {
            newNavButtons =
                newNavButtons === "none" /* none */
                    ? "right" /* right */
                    : "both" /* both */;
        }
        return newNavButtons;
    };
    Tabs.prototype._getDataAttributes = function (mobile, rtl) {
        var _a;
        var navButtons = this.state.navButtons;
        var skin = this.props.skin;
        return _a = {},
            _a[dataHooks_1.TABS_DATA_KEYS.skin] = skin,
            _a[dataHooks_1.TABS_DATA_KEYS.mobile] = mobile,
            _a[dataHooks_1.TABS_DATA_KEYS.rtl] = rtl,
            _a[dataHooks_1.TABS_DATA_KEYS.navButtons] = navButtons,
            _a;
    };
    Tabs.prototype.render = function () {
        var _this = this;
        var _a = this.state, navButtons = _a.navButtons, animateIndicator = _a.animateIndicator, selectedTab = _a.selectedTab;
        var _b = this.props, items = _b.items, alignment = _b.alignment, skin = _b.skin, variant = _b.variant, className = _b.className, ariaLabel = _b["aria-label"], ariaLabelledBy = _b["aria-labelledby"], activeTabIndex = _b.activeTabIndex, isTablist = _b.isTablist, onKeyDown = _b.onKeyDown;
        var leftButtonWidth = this._leftButtonRef
            ? this._leftButtonRef.width()
            : 0;
        var rightButtonWidth = this._rightButtonRef
            ? this._rightButtonRef.width()
            : 0;
        return (React.createElement(TPAComponentsConfig_1.TPAComponentsConsumer, null, function (_a) {
            var mobile = _a.mobile, rtl = _a.rtl;
            return (React.createElement("div", __assign({ className: Tabs_st_css_1.st(Tabs_st_css_1.classes.root, { skin: skin, navButtons: navButtons, mobile: mobile }, className) }, _this._getDataAttributes(mobile, rtl), { "data-hook": _this.props['data-hook'] }, (isTablist && {
                role: 'tabpanel',
                tabIndex: 0,
                onFocus: function (e) {
                    //focus on tab only when tabpanel is focused initialy
                    if (e.target === e.currentTarget) {
                        _this._tabsRef._setTabFocus(activeTabIndex);
                    }
                },
            }), { onKeyDown: onKeyDown && onKeyDown }),
                React.createElement(react_resize_detector_1.default, { handleWidth: true, onResize: _this._onResize }),
                React.createElement(ScrollableTabs_1.ScrollableTabs, { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, alignment: alignment, variant: variant, items: items, className: Tabs_st_css_1.classes.navigation, onClickItem: _this._onClickItem, onScroll: _this._updateButtonsIfNeeded, activeTabIndex: selectedTab, animateIndicator: animateIndicator, ref: _this._tabsRefCallback, rtl: rtl, scrollButtons: {
                        left: leftButtonWidth,
                        right: rightButtonWidth,
                    }, isTablist: isTablist }),
                React.createElement(TabsNavButton_1.TabsNavButton, { onClick: _this._onClickLeft, className: classnames_1.default(Tabs_st_css_1.classes.navBtn, Tabs_st_css_1.classes.navBtnLeft), tabIndex: "right" /* right */ ? -1 : 0, "data-hook": dataHooks_1.TABS_DATA_HOOKS.leftNavButton, ref: _this._rightButtonRefCallback },
                    React.createElement(ChevronLeft_svg_1.ReactComponent, null)),
                React.createElement(TabsNavButton_1.TabsNavButton, { onClick: _this._onClickRight, className: classnames_1.default(Tabs_st_css_1.classes.navBtn, Tabs_st_css_1.classes.navBtnRight), tabIndex: "left" /* left */ ? -1 : 0, "data-hook": dataHooks_1.TABS_DATA_HOOKS.rightNavButton, ref: _this._leftButtonRefCallback },
                    React.createElement(ChevronRight_svg_1.ReactComponent, null)),
                React.createElement("div", { className: Tabs_st_css_1.classes.border })));
        }));
    };
    Tabs.defaultProps = {
        skin: constants_1.SKIN.fullUnderline,
        variant: constants_1.VARIANT.fit,
        alignment: constants_1.ALIGNMENT.center,
        isTablist: false,
    };
    return Tabs;
}(React.Component));
exports.Tabs = Tabs;
//# sourceMappingURL=Tabs.js.map